import { useTranslation } from "react-i18next";
import { CountryAccesses as CountryAccessesFeature } from "@/partner/features/countryAccesses";
import { Meta } from "@/shared/components";

export function CountryAccessesPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("countryAccesses.pageTitle")} pageType="Partner" />
      <CountryAccessesFeature />
    </>
  );
}
